import { Directive, ElementRef, HostListener } from '@angular/core';

declare const $: any;

@Directive({
  selector: '[appCloseModal]'
})
export class CloseModalDirective {

  constructor(private el: ElementRef) {}

  @HostListener('click') onClick() {
    const modal = document.getElementById('unassigned');
    if (modal) {
      $("#unassigned").modal("hide");
    }
  }
}